import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { Button, ButtonTypes } from 'components/button';

import * as Styles from './styles';
import { RowFormButtonsProps } from './types';

export const RowFormButtons = ({
  marginTop = 24,
  submitButtonProps,
  deleteButtonProps,
}: RowFormButtonsProps) => {
  return (
    <Styles.BlockButtons marginTop={marginTop}>
      <Button
        icon={<Icon.Delete />}
        colorType={ButtonColors.LightRed}
        {...deleteButtonProps}
      />

      <Button
        type={ButtonTypes.Submit}
        icon={<Icon.CheckCircle />}
        colorType={ButtonColors.LightGreen}
        {...submitButtonProps}
      />
    </Styles.BlockButtons>
  );
};
